import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Yugal Kunj</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Providing quality programs for spiritual and cultural development.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Programs</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="https://ykportal.yugalkunj.org/Home/CountrySelect" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-200">Camp</a></li>
              <li><a href="https://ykportal.yugalkunj.org/Home/CountrySelect" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-200">Retreat</a></li>
              <li><a href="/" className="hover:text-white transition-colors duration-200">Events</a></li>
              <li><a href="https://ykportal.yugalkunj.org/Home/CountrySelect" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-200">Tiffin</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="https://ykportal.yugalkunj.org/home/contact" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-200">Contact Us</a></li>
              <li><a href="#" className="hover:text-white transition-colors duration-200">FAQ</a></li>
              <li><a href="#" className="hover:text-white transition-colors duration-200">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-white transition-colors duration-200">Terms of Service</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <p className="text-gray-400 text-sm mb-2 break-words">
              Email: info@yugalkunj.org
            </p>
            <p className="text-gray-400 text-sm">
              Phone: (555) 123-4567
            </p>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8">
          <p className="text-center text-gray-400 text-sm">
            &copy; 2024 Yugal Kunj. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
